module.exports = __webpack_public_path__ + "img/bhs.9f8a4eae.svg";